import { RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RedbaxAuthProvider, ProtectedRoute } from '@redbax/shared';
import { AdminBffClientProvider } from '@redbax/ui-admin';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <RedbaxAuthProvider>
      <ProtectedRoute>
        <QueryClientProvider client={queryClient}>
          <AdminBffClientProvider>
            <RouterProvider router={router} />
          </AdminBffClientProvider>
        </QueryClientProvider>
      </ProtectedRoute>
    </RedbaxAuthProvider>
  );
}
